import { Text } from '@change/ds-core-ui';
import { ReminderIcon } from '@change/ds-icons';
import { Grid } from '@change/ds-layout';

import { Translate } from '@change-corgi/core-react/i18n';

import { StepActions } from '#src/app/pages/startAPetitionV2/shared/components';
import { Html } from '#src/app/shared/components/html';
import { useRichMediaTransformers } from '#src/app/shared/hooks/richMedia';

import { BannerActions } from './components/BannerActions';
import { Hero } from './components/Hero';
import { usePreview } from './hooks/usePreview';

export const Preview: React.FC = () => {
	const { data, actions } = usePreview();
	const { decodeRichMediaTransformer } = useRichMediaTransformers();

	return (
		// NOTE: 88px is the height of the StepActions component and 61px is the height of the header
		// min-h-[calc(100vh-88px-61px)] ensures that the content area takes up at least the full height of the viewport minus the header and step actions
		// grid-rows-[auto_min-content] ensures the content area takes up remaining space while the bottom banner keeps its natural height
		// mb-[88px] ensures that there is enough space at the bottom for the StepActions component when it is fixed to the bottom of the viewport
		<div className="bg-background-overlay mb-22 grid min-h-[calc(100vh-88px-61px)] grid-rows-[auto_min-content]">
			<Grid className="pt-4 md:pt-8">
				<div className="bg-background-base col-span-full overflow-hidden rounded-tl-xl rounded-tr-xl">
					{/* Heading + Image */}
					<Hero status={data.jobStatus} imageSrc={data.imageSrc}>
						{data.ask}
					</Hero>

					{/* Description */}
					<Grid className="px-0 py-8 md:py-14">
						<div className="col-span-full min-h-[50vh] space-y-4 px-4 md:col-span-6 md:col-start-2 md:px-0 lg:col-span-8 lg:col-start-3">
							<Text as="h2" variant="heading">
								<Translate value="corgi.start_a_petition.preview.description_heading" />
							</Text>
							<Html html={data.description} className="font-serif" transformers={[decodeRichMediaTransformer]} />
						</div>
					</Grid>
				</div>
			</Grid>
			<BannerActions
				title={<Translate value="corgi.start_a_petition.preview.banner_actions.bottom.heading" />}
				description={<Translate value="corgi.start_a_petition.preview.banner_actions.bottom.description" />}
				icon={<ReminderIcon />}
			/>
			<StepActions
				className="md:bg-background-base! px-0! py-4! md:fixed! md:right-0! md:bottom-0! md:left-0! md:border-t! md:shadow-md! [&>div]:container"
				type="navigation"
				onPrimaryAction={actions.submit}
				onSecondaryAction={actions.back}
			/>
		</div>
	);
};
